<app-listing-layout [showFilterPanel]="false">
  <div content>
    <div *ngIf="isLoading" class="skeleton-page-header">
      <div class="content-header-copy">
        <ejs-skeleton shape="Text" width="104px" height="11px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="480px" height="14px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="380px" height="14px"></ejs-skeleton>
      </div>
      <ejs-skeleton shape="Text" width="140px" height="16px"></ejs-skeleton>
    </div>

    <div *ngIf="isLoading" class="skeleton-grid-wrapper">
      <div class="skeleton-grid">
        <div class="skeleton-grid-header">
          <div class="skeleton-cell" style="width: 260px;">
            <ejs-skeleton shape="Text" width="90px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 136px;">
            <ejs-skeleton shape="Text" width="88px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 136px;">
            <ejs-skeleton shape="Text" width="94px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 220px;">
            <ejs-skeleton shape="Text" width="140px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 230px;">
            <ejs-skeleton shape="Text" width="120px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 100px;">
            <ejs-skeleton shape="Text" width="55px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 160px;">
            <ejs-skeleton shape="Text" width="130px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 148px;">
            <ejs-skeleton shape="Text" width="72px" height="14px"></ejs-skeleton>
          </div>
        </div>

        <div class="skeleton-grid-row" *ngFor="let row of [1,2,3,4,5,6]">
          <div class="skeleton-cell" style="width: 260px;">
            <ejs-skeleton shape="Text" [width]="getRandomWidth(170, 235)" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 136px;">
            <ejs-skeleton shape="Text" width="86px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 136px;">
            <ejs-skeleton shape="Text" width="86px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 220px;">
            <ejs-skeleton shape="Text" [width]="getRandomWidth(120, 180)" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 230px;">
            <ejs-skeleton shape="Text" [width]="getRandomWidth(140, 200)" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 100px;">
            <ejs-skeleton shape="Text" width="30px" height="14px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 160px;">
            <ejs-skeleton shape="Rectangle" width="96px" height="24px"></ejs-skeleton>
          </div>
          <div class="skeleton-cell" style="width: 148px;">
            <ejs-skeleton shape="Rectangle" width="112px" height="30px"></ejs-skeleton>
          </div>
        </div>
      </div>

      <div class="skeleton-pagination">
        <div class="skeleton-pagination-left">
          <ejs-skeleton shape="Text" width="120px" height="14px"></ejs-skeleton>
        </div>
        <div class="skeleton-pagination-right">
          <ejs-skeleton shape="Rectangle" width="35px" height="32px"></ejs-skeleton>
          <ejs-skeleton shape="Rectangle" width="35px" height="32px"></ejs-skeleton>
          <ejs-skeleton shape="Rectangle" width="35px" height="32px"></ejs-skeleton>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoading && !hasPasswordConfigured" class="no-password-notice">
      <div class="no-password-notice__icon">🔒</div>
      <p class="no-password-notice__message">
        Para acessar o histórico de eleições, é necessário ter uma senha cadastrada na sua conta.
      </p>
      <button ejs-button type="button" cssClass="e-primary" (click)="goToMyAccount()">
        Cadastrar senha
      </button>
    </div>

    <ng-container *ngIf="!isLoading && hasPasswordConfigured">
      <div class="content-header">
        <div class="content-header-copy">
          <span class="content-kicker">Histórico do participante</span>
          <p class="content-description">
            Consulte abaixo as eleições da CIPA em que a sua participação ficou vinculada para acompanhamento e
            conferência.
          </p>
        </div>

        <span class="results-count">
          <strong>{{ elections.length }}</strong> eleição{{ elections.length !== 1 ? 'ões' : '' }} encontrada{{
          elections.length !== 1 ? 's' : '' }}
        </span>
      </div>

      <ejs-grid [dataSource]="elections" [allowPaging]="true" [allowSorting]="true" [allowFiltering]="true"
        [allowResizing]="true" [pageSettings]="pageSettings" [filterSettings]="filterSettings" height="auto">

        <e-columns>
          <e-column field="name" headerText="Eleição" width="260"></e-column>
          <e-column field="votingStartAt" headerText="Abertura" width="136" textAlign="Center">
            <ng-template #template let-data>
              <div class="date-cell">
                <strong>{{ data.votingStartAt | date:'dd/MM/yyyy' }}</strong>
                <span>{{ data.votingStartAt | date:'HH:mm' }}</span>
              </div>
            </ng-template>
          </e-column>
          <e-column field="votingEndAt" headerText="Encerramento" width="136" textAlign="Center">
            <ng-template #template let-data>
              <div class="date-cell">
                <strong>{{ data.votingEndAt | date:'dd/MM/yyyy' }}</strong>
                <span>{{ data.votingEndAt | date:'HH:mm' }}</span>
              </div>
            </ng-template>
          </e-column>
          <e-column field="establishmentName" headerText="Estabelecimento" width="220"></e-column>
          <e-column field="companyName" headerText="Empresa" width="230"></e-column>
          <e-column field="alreadyVoted" headerText="Votou" width="100" textAlign="Center">
            <ng-template #template let-data>
              <span>{{ data.alreadyVoted ? 'Sim' : 'Não' }}</span>
            </ng-template>
          </e-column>
          <e-column field="status" headerText="Status" width="160" textAlign="Center">
            <ng-template #template let-data>
              <span class="status-badge" [ngClass]="getStatusClass(data.status)">{{ getStatusLabel(data.status)
                }}</span>
            </ng-template>
          </e-column>
          <e-column headerText="Resultado" width="148" textAlign="Center" [allowFiltering]="false"
            [allowSorting]="false">
            <ng-template #template let-data>
              <button ejs-button type="button" cssClass="e-outline e-small"
                [disabled]="!data.resultsAvailable && data.status !== 'votacao'"
                (click)="openElectionResult(data.companySuffix, data.electionGuid)">
                {{ data.status === 'votacao' ? 'Votar / Ver' : 'Abrir resultado' }}
              </button>
            </ng-template>
          </e-column>
        </e-columns>
      </ejs-grid>
    </ng-container>
  </div>
</app-listing-layout>
